export const ApiErrors = Object.freeze({
    DateExpired: 40006,
    RepeatedQR: 42069,
});